import {
  LOAD_ENGINEERS,
  EngineersState,
  EngineerAction,
  FETCH_ENGINEERS,
  REMOVE_ENGINEER,
  PERSIST_ENGINEER,
  SET_ENGINEERS_DATE_FILTER,
} from "./EngineersTypes";
import { Engineer } from "msd-capacity-planning-model";
import { dateFilterStorage } from "../utils/dateFilterStorage";

const initialState: EngineersState = {
  items: {},
  synching: true,
  dateFilter: dateFilterStorage.get() || undefined,
};

export default function teamsReducer(
  state = initialState,
  action: EngineerAction
): EngineersState {
  switch (action.type) {
    case FETCH_ENGINEERS:
      return {
        ...state,
        synching: true,
      };
    case REMOVE_ENGINEER:
      return {
        ...state,
        synching: true,
      };
    case PERSIST_ENGINEER:
      return {
        ...state,
        synching: true,
      };
    case LOAD_ENGINEERS: {
      const dateFilter = action.dateFilter || state.dateFilter;
      const filterDate = dateFilter ? new Date(dateFilter) : (() => {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        return oneYearAgo;
      })();
      console.log(`FilterDate:${filterDate}`);
      const items = action.items.reduce(
        (all: { [id: string]: Engineer }, e) => {
          // Only add the engineers if they don't have an offboardingDate or it's after the filter date
          if (!e.offboardDate || (
            e.offboardDate &&
            new Date(e.offboardDate.year, e.offboardDate.month, e.offboardDate.day) >= filterDate
          )) {
            e.skills = e.skills || [];
            e.utilization = e.utilization || [];
            e.timeOff = e.timeOff || [];
            all[e.id] = e;
          }
          return all;
        },
        {}
      );
      console.log(items.length);
      return {
        ...state,
        items,
        synching: false,
        dateFilter,
      };
    }
    case SET_ENGINEERS_DATE_FILTER: {
      // Save to localStorage
      dateFilterStorage.set(action.dateFilter);
      return {
        ...state,
        dateFilter: action.dateFilter,
      };
    }
    default:
      return state;
  }
}
